import { useEffect } from "react";

import { AddReceivingInvoiceViewModel } from "../../viewmodels/receiving/AddReceivingInvoiceViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import AddReceivingInvoiceForm from "../../components/forms/receiving//AddReceivingInvoiceForm";
import EmptyModal from "../../components/modals/EmptyModal";

function AddReceivingInvoice(props) {
  const { addSnackbar, logout } = props;
  const {
    emptyModal,
    getTruckOptionsForDropdown,
    setEmptyModelOpen,
    truckOptions,
    fetchPosForTruck,
    supplierOptions,
    getSupplierOptionsForDropdown,
    productOptions,
    getProductOptionsForDropdown,
    onFetchProductDetails,
    poOptions,
    receiving,
    createReceivingInvoice,
    addItemToReceiving,
    askDeleteReceivingItemById,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    isEdit,
    updateReceivingInvoice,
    employeeOptions,
    getEmployeeOptionsForDropdown,
    getWarehouses,
    getWarehouseLocations,
    onDeleteReceivingInvoice,
    deleteReceivingInvoiceDocument,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    showErrorModal,
    carrierOptions,
    getCarriersForDropdown,
  } = AddReceivingInvoiceViewModel(logout, addSnackbar);

  useEffect(() => {
    getTruckOptionsForDropdown();
    getSupplierOptionsForDropdown();
    getProductOptionsForDropdown();
    getEmployeeOptionsForDropdown();
    getCarriersForDropdown();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div>
          <AddReceivingInvoiceForm
              isEdit={isEdit}
              truckOptions={truckOptions}
              fetchPosForTruck={fetchPosForTruck}
              productOptions={productOptions}
              supplierOptions={supplierOptions}
              onFetchProductDetails={onFetchProductDetails}
              poOptions={poOptions}
              setEmptyModelOpen={setEmptyModelOpen}
              receiving={receiving}
              createReceivingInvoice={createReceivingInvoice}
              addItemToReceiving={addItemToReceiving}
              askDeleteReceivingItemById={askDeleteReceivingItemById}
              updateReceivingItem={updateReceivingItem}
              openDeleteItemByBarcodePopup={openDeleteItemByBarcodePopup}
              updateReceivingInvoice={updateReceivingInvoice}
              employeeOptions={employeeOptions}
              getWarehouses={getWarehouses}
              getWarehouseLocations={getWarehouseLocations}
              isNewFlow={true}
              onDeleteReceivingInvoice={onDeleteReceivingInvoice}
              deleteReceivingInvoiceDocument={deleteReceivingInvoiceDocument}
              addSnackbar={addSnackbar}
              askReturnSelectedItems={askReturnSelectedItems}
              selectedItems={selectedItems}
              carrierOptions={carrierOptions}
              setSelectedItems={setSelectedItems}
              showErrorModal={showErrorModal}
            />
        </div>
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddReceivingInvoice),
);
